import { render, staticRenderFns } from "./btn-radio.vue?vue&type=template&id=71f1a36e&scoped=true"
import script from "./btn-radio.vue?vue&type=script&lang=ts"
export * from "./btn-radio.vue?vue&type=script&lang=ts"
import style0 from "./btn-radio.vue?vue&type=style&index=0&id=71f1a36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1a36e",
  null
  
)

export default component.exports